module.exports = __webpack_public_path__ + "img/branch.d7d101b8.png";